var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alarm-status"},[_c('icon-with-badge',{attrs:{"material-icon":_vm.icon,"badge":_vm.badge,"badge-color":_vm.badgeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }